import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  getNotifLocal,
  setNotifLocal,
  parseUserNotifPrefs
} from '../../utils/mobileSettingsStorage';
import './MobileNotificationChannelPage.css';

const TITLES = {
  push: 'Push',
  email: 'Email',
  in_app: 'In-app messages'
};

const defaultPrefs = () => ({
  systemPush: false,
  channels: { push: true, email: true, inApp: true }
});

export default function MobileNotificationChannelPage() {
  const { channel } = useParams();
  const navigate = useNavigate();
  const { user, updateProfile } = useAuth();
  const [prefs, setPrefs] = useState(getNotifLocal);
  const key = useMemo(() => {
    if (channel === 'email') return 'email';
    if (channel === 'in_app' || channel === 'in-app') return 'inApp';
    return 'push';
  }, [channel]);

  const title = TITLES[channel] || TITLES.in_app;

  const merge = useCallback(() => {
    if (user?.notificationPrefs) {
      const p = parseUserNotifPrefs(user.notificationPrefs);
      if (p) {
        setPrefs((prev) => ({ ...defaultPrefs(), ...prev, ...p }));
        return;
      }
    }
    setPrefs(getNotifLocal());
  }, [user]);

  useEffect(() => {
    merge();
  }, [merge]);

  const channelOn = (() => {
    const ch = prefs.channels || defaultPrefs().channels;
    if (key === 'inApp') return !!ch.inApp;
    if (key === 'email') return !!ch.email;
    return !!ch.push;
  })();

  const setChannel = async (on) => {
    const ch = { ...((prefs.channels || defaultPrefs().channels)) };
    if (key === 'inApp') ch.inApp = on;
    else if (key === 'email') ch.email = on;
    else ch.push = on;
    const next = { ...prefs, channels: ch };
    setPrefs(next);
    setNotifLocal(next);
    if (user) {
      await updateProfile({ notificationPrefs: JSON.stringify(next) });
    }
  };

  return (
    <div className="mncp-page">
      <div className="mncp-header">
        <button type="button" className="mncp-back" onClick={() => navigate(-1)} aria-label="Back">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h1 className="mncp-title">{title}</h1>
      </div>
      <div className="mncp-body">
        <p className="mncp-hint">
          {key === 'email' && 'Choose whether we may email you about orders and account activity.'}
          {key === 'push' && 'Control push messages for this device. System permission is also required for delivery.'}
          {key === 'inApp' && 'Show messages inside the app, such as order updates and promotions.'}
        </p>
        <label className="mncp-row">
          <span>Enabled</span>
          <input
            type="checkbox"
            className="mncp-check"
            checked={channelOn}
            onChange={(e) => setChannel(e.target.checked)}
          />
        </label>
      </div>
    </div>
  );
}
